module.exports = __webpack_public_path__ + "img/close.c6578eb4.svg";